// Module
var code = "{tplPath}{tplFile}{tplExtension} not found!\n";
// Exports
module.exports = code;